export const LEAVE_QUERY_KEYS = {
  LEAVE_BALANCE: 'leaveBalance',
  WELL_BEING_LEAVE_CREDITS: 'wellBeingLeaveCredits',
} as const;

export const ROLE_QUERY_KEYS = {
  ROLES: 'roles',
  PERMISSIONS: 'permissions',
  ROLES_PERMISSIONS: 'rolesPermissions',
  MY_ROLE: 'myRole',
} as const;

export const USER_INFO_QUERY_KEYS = {
  USER_INFO: 'userInfo',
} as const;

export const FISCAL_YEAR_QUERY_KEYS = {
  BY_COUNTRY: 'fiscalYearByCountry',
} as const;

export const ATTENDANCE_QUERY_KEYS = {
  SUMMARY: 'summary',
  ROSTER: 'roster',
} as const;

export const USER_QUERY_KEYS = {
  TEAMS: 'userTeams',
  ALLOCATIONS: 'userAllocations',
} as const;

export const GOAL_QUERY_KEYS = {
  USER_GOALS: 'userGoals',
  USER_GOALS_SUMMARY: 'userGoalsSummary',
  USER_FEEDBACKS: 'userFeedbacks',
  GOAL_FEEDBACKS: 'goalFeedbacks',
} as const;

export const SKILL_QUERY_KEYS = {
  GLOBAL_RATINGS: 'globalRatings',
  SELECTED_SKILLS: 'selectedSkills',
} as const;

export const QUICK_LINK_QUERY_KEYS = {
  QUICK_LINKS: 'quickLinks',
} as const;

export const ASSET_QUERY_KEYS = {
  ASSETS_BY_ID: 'assets',
} as const;
